var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38573 7.5H19.5261C20.5962 7.5 21.6226 7.92143 22.3793 8.67157C23.136 9.42172 23.5612 10.4391 23.5612 11.5V23.5C23.5612 23.7652 23.4549 24.0196 23.2657 24.2071C23.0765 24.3946 22.8199 24.5 22.5524 24.5H6.41204C5.34187 24.5 4.31553 24.0786 3.5588 23.3284C2.80208 22.5783 2.37695 21.5609 2.37695 20.5V8.5C2.37695 8.23478 2.48323 7.98043 2.67242 7.79289C2.8616 7.60536 3.11818 7.5 3.38573 7.5V7.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5605 14L30.622 10V22L23.5605 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.911ea470bd7ba32d0da05abd22326f7f.svg";
export { ForwardRef as ReactComponent };